export default "__VITE_ASSET__f5095b0e__"